import { hexStripZeros as A } from "@ethersproject/bytes";
import p from "../../../config/index.js";
import { TRANSACTION_BLOCK_TIMEOUT as f } from "../../../constants/chain.js";
import { WalletType as i, WALLET_CONNECT_METADATA as T } from "../../../constants/web3.js";
import w from "../../config/network-mainnet.json.js";
import v from "../../config/network-testnet.json.js";
import e from "./Web3Instance.js";
import { saveProvider as C, cleanProvider as N } from "../../../util/authenication/index.js";
import g from "@walletconnect/universal-provider";
import { Web3Modal as y } from "@web3modal/standalone";
import * as a from "ramda";
import d from "web3";
let n = null, c = null;
const o = class o {
};
o.requestLogin = async () => {
  if (!(e.walletType !== i.WalletConnect && e.walletType !== i.None))
    try {
      const t = p.VARIABLES.IS_TESTNET ? v : w;
      if (!n) {
        const r = e.walletConnectId;
        n = await g.init({
          projectId: r,
          logger: "info",
          relayUrl: p.URL.WALLETCONNECT_RELAY,
          metadata: T
        }), c = new y({
          projectId: r,
          walletConnectVersion: 2
        }), n.on("display_uri", (s) => {
          c == null || c.openModal({
            uri: s
          });
        }), n.on("session_delete", o.handleDisconnect);
      }
      e.currentProvider = n;
      const l = `eip155:${Number(t.chainId)}`, {
        session: u
      } = n;
      if (a.isNil(u)) {
        await n.connect({
          namespaces: {
            eip155: {
              methods: ["eth_sendTransaction", "eth_signTransaction", "eth_sign", "personal_sign", "eth_signTypedData"],
              chains: [l],
              events: ["chainChanged", "accountsChanged"],
              rpcMap: {
                [l]: t.rpcUrls[0]
              }
            }
          }
        }), e.currentWeb3 = new d(n);
        const r = await n.enable();
        e.currentWeb3.walletAddress = a.propOr("", "0", r), c == null || c.closeModal();
      } else {
        const r = a.pipe(a.pathOr([], ["namespaces", "eip155", "accounts"]), a.find((s) => {
          const h = a.split(":", s);
          return Number(h[1]) === Number(t.chainId);
        }), a.defaultTo(""), a.split(":"), a.last);
        e.currentWeb3 = new d(n), e.currentWeb3.walletAddress = r(u);
      }
      if (e.currentWeb3.eth.transactionBlockTimeout = f, n.request({
        method: "eth_accounts"
      }).catch((r) => {
        console.error(r);
      }), e.walletType === i.WalletConnect && (e.currentActiveAccount = e.currentWeb3.walletAddress, await e.updateInfo(), e.currentActiveAccount)) {
        const r = await e.currentWeb3.eth.getCode(e.currentActiveAccount);
        e.isSmartContractWallet = r && A(r) !== "0x";
      }
      C(i.WalletConnect);
    } catch (t) {
      console.error(t);
    }
}, o.handleAccountsChanged = async (t) => {
  e.walletType === i.WalletConnect && (t.length === 0 ? e.currentActiveAccount = "" : t[0] !== e.currentActiveAccount && (e.currentActiveAccount = t[0]), await e.updateInfo());
}, o.handleChainChanged = (t) => {
  console.info(`walletconnect > chain changed > ${t}`);
}, o.handleDisconnect = async () => {
  e.currentProvider = null, e.currentWeb3 = null, e.currentActiveAccount = "", e.walletType = i.None, N(), await e.updateInfo();
};
let m = o;
export {
  m as default
};
//# sourceMappingURL=WalletConnect.js.map
